export enum AmplifyImpactInfoEvents {
  keyInitiativeEditorRequested = 'keyInitiativeEditorRequested',
  keyInitiativeEditorLoadingChanged = 'keyInitiativeEditorLoadingChanged',
}
